import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// Watches the "record to remove" and "record to keep" selects on the deduplication tool.
// When both are chosen, it fetches the merge preview (side-by-side comparison + affected
// deals + cross-brokerage warning) as a turbo-stream that replaces the #dedup-preview frame.
export default class extends Controller {
  static targets = ["remove", "keep"];
  static values = { url: String, templateType: String };

  change() {
    const removeId = this.removeTarget.value;
    const keepId = this.keepTarget.value;

    if (!removeId || !keepId) return;

    // template_type is required so the server picks the right config and can decode composite
    // "Company:id" / "Individual:id" keys — without it the preview falls back to Brokers.
    get(this.urlValue, {
      query: { template_type: this.templateTypeValue, remove_id: removeId, keep_id: keepId },
      responseKind: "turbo-stream",
    });
  }
}
